import { NgModule } from '@angular/core';

import { NameModule } from '@ap/tokens-browser';

import { NameWrapperComponent } from './name.wrapper.component';

/**
 * @name NameWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [NameWrapperComponent],
    imports: [NameModule],
    exports: [NameWrapperComponent]
})
export class NameWrapperModule {}
